import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import {
  ROUTE_CLIENT_EMAIL_CAMPAIGNS,
} from "../../../../config/routes";
import { EmailCampaignDetailsTable } from './view/EmailCampaignDetailsTable';

function EmailCampaignDetailsTab(props) {
  const { emailCampaign } = props;

  return (
    <div className="email-campaign-details-pane">
      <div className="email-campaign-details-table-wrap">
        <EmailCampaignDetailsTable emailCampaign={emailCampaign}/>
      </div>
      <div className="email-campaign-details-actions">
        <Link className="btn btn-secondary" to={ROUTE_CLIENT_EMAIL_CAMPAIGNS}>
          <FormattedMessage id="messages.go_back"/>
        </Link>
      </div>
    </div>
  );
}

export { EmailCampaignDetailsTab };
